import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-requirements[passwordCtrName][confirmCtrName]',
  templateUrl: './password-requirements.component.html',
  styleUrls: ['./password-requirements.component.scss']
})
export class PasswordRequirementsComponent implements OnInit {
  @Input() passwordCtrName!: string;
  @Input() confirmCtrName!: string;
  @Input() reqNew = false;
  /** max 4, for more change css */
  @Input() columns = 2;

  constructor() {}

  ngOnInit() {}
}
